import { ListUsersQuery } from 'generated/graphql';
import { ListUsersItem } from 'v2/core/repository/edge-server/types/listUsers';

export const mapListUsersItems = (data: ListUsersQuery): ListUsersItem[] => {
  return (
    data.listUsers?.users?.map((user) => ({
      id: user.id,
      email: user.email,
      firstName: user.firstName ?? '',
      lastName: user.lastName ?? '',
    })) ?? []
  );
};
